// removed by extract-text-webpack-plugin
module.exports = {"button":"ContainedButton_button_1yfz5","disabled":"ContainedButton_disabled_1cLH_"};